import React from 'react';
import styled from 'styled-components';
import {
  BaseBox,
  CenterBox,
  Heading4,
  PrimaryButton,
  Icons,
  DoconModal,
  DoconModalContent,
} from '@docon/docon-ui-library';
import { colors } from 'utilities/colorConfig';

interface IProps {
  onClose: () => void;
}

const Content = styled(BaseBox)`
  padding: 28px 25px 40px;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.primaryColor};
  text-align: center;

  ${CenterBox} {
    margin-bottom: 15px;
    border-radius: 50%;
    color: ${colors.white};
  }

  ${Heading4} { font-weight: bold; margin-bottom: 24px; }

  > * {
    margin-left: auto;
    margin-right: auto;
  }
`;

const Modal = styled<any>(DoconModal)`
  max-width: calc(100vw - 50px);
  border-radius: 10px;

  ${DoconModalContent} {
    padding: 0;
  }
`;

const ConcernSubmitted = ({
  onClose,
}: IProps) => {

  const subHeading = 'We want you to sit back & relax. Resolving your complaint is our top priority.';
  const text = 'We’ve received your message and will be in touch as soon as possible';

  return (
    <Modal
      isOpen
      centered
      hideFooter
      hideCrossIcon
    >
      <Content>
        <CenterBox size={45} bg={colors.success}><Icons.TickIcon /></CenterBox>
        <Heading4 title={'Concern submitted'} />
        <BaseBox mb='10px' dangerouslySetInnerHTML={{ __html: subHeading }} />
        <BaseBox mb='24px' dangerouslySetInnerHTML={{ __html: text }} />
        <PrimaryButton
          px='50px !important'
          size='small'
          title={'OK'}
          onClick={onClose}
        />
      </Content>
    </Modal>
  );
};

export default ConcernSubmitted;